module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "addcashier"
  }, [_c('div', {
    staticClass: "banner_wrapper"
  }, [_c('el-breadcrumb', {
    attrs: {
      "separator": ">"
    }
  }, [_c('el-breadcrumb-item', {
    staticClass: "first",
    attrs: {
      "to": {
        path: '/main/cashiermanage'
      },
      "replace": ""
    }
  }, [_vm._v("收银员管理")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("添加收银员")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "myform_wrapper"
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "rules": _vm.formrules,
      "model": _vm.form
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "姓名",
      "prop": "opname"
    }
  }, [_c('el-input', {
    staticClass: "panel-select-input-220",
    attrs: {
      "size": "small",
      "type": "text",
      "placeholder": "请输入收银员姓名"
    },
    model: {
      value: (_vm.form.opname),
      callback: function($$v) {
        _vm.$set(_vm.form, "opname", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "form.opname"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "电话",
      "prop": "mobile"
    }
  }, [_c('el-input', {
    staticClass: "panel-select-input-220",
    attrs: {
      "size": "small",
      "type": "text",
      "placeholder": "请输入收银员电话"
    },
    model: {
      value: (_vm.form.mobile),
      callback: function($$v) {
        _vm.$set(_vm.form, "mobile", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "form.mobile"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "主账号"
    }
  }, [_c('span', {
    staticClass: "input-content"
  }, [_vm._v(_vm._s(_vm.shop.mobile))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "收银员编号"
    }
  }, [_c('span', {
    staticClass: "input-content"
  }, [_vm._v(_vm._s(_vm.opuid))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "收银员密码",
      "prop": "password"
    }
  }, [_c('el-input', {
    staticClass: "panel-select-input-220",
    attrs: {
      "size": "small",
      "type": "password",
      "placeholder": "请输入收银员密码"
    },
    model: {
      value: (_vm.form.password),
      callback: function($$v) {
        _vm.$set(_vm.form, "password", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "form.password"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gray-explain"
  }, [_vm._v("* 收银员登陆方式为主账号+收银员编号+收银员密码")])], 1), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "form-submit_wrapper"
  }, [_c('span', {
    staticClass: "cancel",
    on: {
      "click": _vm.cancelCreat
    }
  }, [_vm._v("放弃添加")]), _vm._v(" "), _c('div', {
    staticClass: "panel-btn__download panel-btn__download_detail",
    on: {
      "click": _vm.submit
    }
  }, [(_vm.loading1) ? _c('span', {
    staticClass: "el-icon-loading"
  }) : _c('span', [_vm._v("提交")])])])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-header panel-header__fix"
  }, [_c('div', {
    staticClass: "panel-select-group"
  }, [_c('span', {
    staticClass: "panel-header__desc"
  }, [_vm._v("输入收银员信息")])])])
}]}


//////////////////
// WEBPACK FOOTER
// /home/qfpay/fe_node_modules/v7.10.1/fe_chain_store_admin/~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-37415cd5"}!/home/qfpay/fe_node_modules/v7.10.1/fe_chain_store_admin/~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/addcashier/addcashier.vue
// module id = 822
// module chunks = 0